// 设置头部标题
export const SET_HEAD_TITLE = 'set_head_title'

// 接收用户信息
export const RECEIVE_USER = 'receive_user'

/// 重置用户信息
export const RESET_USER = 'reset_user'
